import API from "@/services/api";
import { CRMCaseResponse, CRMFormData } from "../types/CRMForm";

export enum Endpoints {
  CRMCase = "/crm/cases/",
}

export const sendCRMFormData = (
  data: CRMFormData,
) => {
  return new Promise<CRMCaseResponse>(async (resolve, reject) => {
    API.post<CRMCaseResponse, CRMFormData>({
      endpoint: Endpoints.CRMCase,
      data,
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}